import React, { useContext } from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import * as styles from '../../check-in-employees.styles';
import DayPartRoomCard from '../../cards/day-part-cards/day-part-room-card.component';
import Column from '../../../../core/components/column/column.component';
import { IsMobileContext } from '../../../../core/context/is-mobile';
import type RoomObsolete from '../../../offices/models/room/room-obsolete';
import { type DayPart } from '../../models/daypart-entry';
import Grid from '../../../../core/components/grid/grid.component';

interface Props {
  readonly dayPart: DayPart;
  readonly rooms: RoomObsolete[] | undefined;
  readonly selectedRoom: RoomObsolete | undefined;
  readonly onRoomSelectionChanged: (room: RoomObsolete) => void;
}

const DayPartRoomGroup = ({ dayPart, rooms, selectedRoom, onRoomSelectionChanged }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  return (
    <div className={style(styles.sectionCard(isMobile))}>
      <Column>
        <span className={style(styles.columnHeader(isMobile))}>{t('rooms').toLocaleUpperCase()}</span>
        {rooms != null && rooms.length === 0 ? (
          <span className={style(styles.emptyListMessage)}>{t('no-rooms-available')}</span>
        ) : (
          rooms != null && (
            <Grid
              rowClass={style(styles.gridRow)}
              numberOfColumns={isMobile ? 1 : 3}
              itemSpacing={12}
              numberOfItems={rooms.length}
              renderItem={(index): React.JSX.Element => {
                const room = rooms[index];
                return (
                  <div className={isMobile ? style(styles.rowItem(true)) : undefined} key={room.id}>
                    <DayPartRoomCard
                      dayPart={dayPart}
                      room={room}
                      isSelected={selectedRoom?.id === room.id}
                      onClick={(value): void => {
                        onRoomSelectionChanged(value);
                      }}
                    />
                  </div>
                );
              }}
            />
          )
        )}
      </Column>
    </div>
  );
};

export default DayPartRoomGroup;
